import React from 'react';

import { Root, Item, Dot, Name } from './Legend.styles';

export type LegendItem = {
  /** Series label (user-visible → rendered through `<Text>`). */
  name: string;
  /** Swatch colour — a token value supplied by the section. */
  color: string;
  dashed?: boolean;
};

/** Chart legend — a right-aligned row of coloured swatch + series name. */
export const Legend = ({ items }: { items: LegendItem[] }): React.ReactElement => (
  <Root>
    {items.map((s) => (
      <Item key={s.name}>
        <Dot $dashed={!!s.dashed} $color={s.color} aria-hidden="true" />
        <Name text={s.name} tag="span" />
      </Item>
    ))}
  </Root>
);

export default Legend;
